import { FormJsonEditorComponent } from './form-json-editor/form-json-editor.component';
import { HierarchyWidgetComponent } from './hierarchy-widget/hierarchy-widget.component';
import { EnvironmentSelectComponent } from './environment-select/environment-select.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  NbActionsModule,
  NbAutocompleteModule,
  NbButtonModule,
  NbCardModule,
  NbContextMenuModule,
  NbIconModule,
  NbInputModule,
  NbLayoutModule,
  NbMenuModule,
  NbSelectModule,
  NbSidebarModule,
  NbSpinnerModule,
  NbTooltipModule,
  NbUserModule,
  NbCheckboxModule,
  NbRadioModule,
  NbPopoverModule,
  NbFormFieldModule,
  NbDatepickerModule,
  NbToggleModule,
  NbAccordionModule,
  NbTimepickerModule,
  NbTreeGridModule,
  NbTagModule,
  NbTabsetModule,
  NbBadgeModule,
  NbListModule,
  NbStepperModule,
} from '@nebular/theme';
import { MonacoEditorModule } from '@materia-ui/ngx-monaco-editor';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { TimeagoModule } from 'ngx-timeago';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomActionsComponent } from './custom-actions/custom-actions.component';
import { FormFieldComponent } from './form-field/form-field.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { DirectivesModule } from '../directives/directives.module';
import { SafeHtmlPipePipe } from './safe-html-pipe.pipe';
import { SmartTableRouterlinkComponent } from './smart-table-routerlink/smart-table-routerlink.component';
import { TableAddComponent } from './table-add/table-add.component';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { InfoComponent } from './info/info.component';
import { PageWrapperComponent } from './page-wrapper-component/page-wrapper.component';
import { DiffIconComponent } from './diff-icon/diff-icon.component';
import { CheckboxComponent } from './form/checkbox/checkbox.component';
import { NumberInputComponent } from './form/number-input/number-input.component';
import { ProfilesComponent } from './profiles/profiles.component';
import { AccessForbiddenComponent } from './access-forbidden/access-forbidden.component';
import { MessageComponent } from './message/message.component';
import { RadioComponent } from './form/radio/radio.component';
import { RBACButtonComponent } from './rbac-button/rbac-button.component';
import { TabPageHeaderComponent } from './tab-page-header/tab-page-header.component';
import { TrimWhiteSpace } from './trim-white-space.pipe';
import { SmartTableWithBadgeComponent } from './smart-table-with-badge/smart-table-with-badge.component';
import { TerminalComponent } from './terminal/terminal.component';
import { DateTimePickerComponent } from './date-time-picker/date-time-picker.component';
import { ToggleComponent } from './form/toggle/toggle.component';
import { SmartTableWithIconComponent } from './smart-table-with-icon/smart-table-with-icon.component';
import { SmartTableWithCountdownComponent } from './smart-table-with-countdown/smart-table-with-countdown.component';
import { CountdownModule } from 'ngx-countdown';
import { SmartTableHyperlinkComponent } from './smart-table-hyperlink/smart-table-hyperlink.component';
import { SmartTableIconTooltipComponent } from './smart-table-icon-tooltip/smart-table-icon-tooltip.component';
import { TagComponent } from './tag/tag.component';
import { SmartTableLongStringEllipsisComponent } from './smart-table-long-string-ellipsis/smart-table-long-string-ellipsis.component';
import { LinkWithEllipsisComponent } from './link-with-ellipsis/link-with-ellipsis.component';
import { SmartTableTextTooltipComponent } from './smart-table-text-tooltip/smart-table-text-tooltip.component';
import { SmartTableTimeagoTooltipComponent } from './smart-table-timeago-tooltip/smart-table-timeago-tooltip.component';
import { SmartTableLinkWithIconComponent } from './smart-table-link-with-icon/smart-table-link-with-icon.component';
import { SaveChangesFooterComponent } from './save-changes-footer/save-changes-footer.component';
import { FormLabelComponent } from './form-label/form-label.component';
import { BadgeWithIconComponent } from './badge-with-icon/badge-with-icon.component';
import { MultiSelectSearchComponent } from './multi-select-search/multi-select-search.component';
import { SelectSingleSearchComponent } from './select-single-search/select-single-search.component';
import { MultiSelectSearchV2Component } from './multi-select-search-v2/multi-select-search-v2.component';
import { SmartTableCellWithEllipsisComponent } from './smart-table-cell-with-ellipsis/smart-table-cell-with-ellipsis.component';
import { PageFooterComponent } from './page-footer/page-footer.component';
import { DeleteConfirmationComponent } from './delete-confirmation/delete-confirmation.component';
import { SmartTableMultiTypeComponent } from './smart-table-multi-type/smart-table-multi-type.component';
import { CountdownComponent } from './countdown/countdown.component';
import { AppAlertsComponent } from './alerts/alerts.component';
import { CustomSpinnerComponent } from './spinner-custom/spinner.custom.component';
import { SmartTableTextareaEditorComponent } from './smart-table-textarea-editor/smart-table-textarea-editor.component';
import { TableSkeletonLoaderComponent } from './table-skeleton-loader/table-skeleton-loader.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ArtifactUriComponent } from './artifact-uri/artifact-uri.component';
import { OverrideDetailsComponent } from './override-details/override-details.component';
import { ReactiveTextAreaComponent } from './reactive-text-area/reactive-text-area.component';
import { ReactiveToggleComponent } from './reactive-toggle/reactive-toggle.component';
import { KubernetesAccountCreateEditComponent } from './kubernetes-account-create-edit/kubernetes-account-create-edit.component';
import { PluralizePipeModule } from 'src/app/pipes/pluralize.pipe.module';
import { StepperListItemComponent } from './stepper-list-item/stepper-list-item.component';
import { VpnInstructionsComponent } from './vpn-instructions/vpn-instructions.component';
import { UserNoteAlertComponent } from './user-note-alert/user-note-alert.component';
import { ReactiveFormFieldComponent } from './reactive-form-field/reactive-form-field.component';
import { TagListComponent } from './tag-list/tag-list.component';
import { AppCollapsibleButtonComponent } from './collapsible-button/collapsible-button.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SmartTableToggleComponent } from './smart-table-toggle/smart-table-toggle.component';
import { QueuedReleasesComponent } from './queued-releases/queued-releases.component';
import { ButtonDropdownComponent } from './button-dropdown/button-dropdown.component';
import { AwsAccountCreateEditComponent } from './aws-account-create-edit/aws-account-create-edit.component';
import { AzureAccountCreateEditComponent } from './azure-account-create-edit/azure-account-create-edit.component';
import { GcpAccountCreateEditComponent } from './gcp-account-create-edit/gcp-account-create-edit.component';
import { ReactiveRadioGroupComponent } from './reactive-radio-group/reactive-radio-group.component';
import { CustomBadgeWithTooltipComponent } from './custom-badge-with-tooltip/custom-badge-with-tooltip.component';
import { SmartTableWithBulkSelectComponent } from './smart-table-with-bulk-select/smart-table-with-bulk-select.component';
import { SmartTableIconSubheadingComponent } from './smart-table-icon-subheading/smart-table-icon-subheading.component';
import { CoderAccountCreateEditComponent } from './coder-account/coder-account.component';
import { SmartTableEditToggleComponent } from './smart-table-edit-toggle/smart-table-edit-toggle.component';
import { OrganizationAccountDetailsComponent } from './organization-account-details/organization-account-details.component';
import { BorderedTextListWithIconComponent } from './bordered-text-list-with-icon/bordered-text-list-with-icon.component';
import { CreateCloudAccountIntegrationComponent } from './create-cloud-account-integration/create-cloud-account-integration.component';
import { CreateVcsAccountIntegrationComponent } from './create-vcs-account-integration/create-vcs-account-integration.component';
import { TokenExpiryUserNoteComponent } from './token-expiry-user-note/token-expiry-user-note.component';
import { TokenExpiryGlobalModalComponent } from './token-expiry-global-modal/token-expiry-global-modal.component';
import { CopyIconWithTooltipComponent } from './copy-icon-with-tooltip/copy-icon-with-tooltip.component';
import { PinImageFormComponent } from './pin-image-form/pin-image-form.component';
import { CloseIconComponent } from './close-icon/close-icon.component';
import { ConfirmActionComponent } from './confirm-action/confirm-action.component';
import { RemoveImageConfirmPopupComponent } from './remove-image-confirm-popup/remove-image-confirm-popup.component';
import { CardHeaderContentComponent } from './card-header-content/card-header-content.component';
import { DesignerCoderComponent } from '../pages/blueprint-designer/designer-coder/designer-coder.component';
import { JsonDynamicFormGroupComponent } from './json-dynamic-form-group/json-dynamic-form-group.component';
import { CardRadioGroupComponent } from './card-radio-group/card-radio-group.component';
import { CardRadioGroupWithShowMoreComponent } from './card-radio-group-with-show-more/card-radio-group-with-show-more.component';
import { ArrayStringInputComponent } from './json-dynamic-form-group/array-string-input/array-string-input.component';
import { DialogPageComponent } from './dialog-page/dialog-page.component';
import { LabelValueV1Component } from './label-value-v1/label-value-v1.component';
import { LabelValueV2Component } from './label-value-v2/label-value-v2.component';
import { AlertsChartComponent } from './alerts-chart/alerts-chart.component';
import { AgChartsAngularModule } from 'ag-charts-angular';
import { ReleaseTrendChartComponent } from './release-trend-chart/release-trend-chart.component';
import { DynamicComponentDirective } from '../directives/dynamic-component.directive';
import { CommitIDsComponent } from './commit-ids/commit-ids.component';
import { SentenceCasePipeModule } from '../pipes/sentencecase.pipe.module';
import { ValidationInfoCardComponent } from './validation-info-card/validation-info-card.component';
import { ListWithCheckComponent } from './list-with-check/list-with-check.component';
import { OnboardingComponent } from './onboarding/onboarding.component';
import { CreateBitbucketAccountIntegrationComponent } from './create-bitbucket-account-integration/create-bitbucket-account-integration.component';
import { ReleaseNotificationPanelComponent } from './release-notification-panel/release-notification-panel.component';
import { PaasSaasSwitchComponent } from './paas-saas-switch/paas-saas-switch.component';
import { InviteUserComponent } from './invite-user/invite-user.component';
import { ShellQuoteInputComponent } from './shell-quote-input/shell-quote-input.component';
import { ReactiveGroupedSelectComponent } from './reactive-grouped-select/reactive-grouped-select.component';
import { ReactiveFormGroupedAutocompleteComponent } from './reactive-form-grouped-autocomplete/reactive-form-grouped-autocomplete.component';
import { MapToIterablePipe } from './map-to-iterable-pipe.pipe';
import { SingleSelectSearchComponent } from './single-select-search/single-select-search.component';
import { VcsAccountCreateEditComponent } from './vcs-account-create-edit/vcs-account-create-edit.component';
import { DropdownWithSearchComponent } from './dropdown-with-search/dropdown-with-search.component';
import { PageActionButtonsComponent } from './page-action-buttons/page-action-buttons.component';
import { SmartTableLinkComponent } from './smart-table-link/smart-table-link.component';
import { SmartTableLinkListComponent } from './smart-table-link-list/smart-table-link-list-component';
import { SmartTableEyeIconEditModeComponent } from './smart-table-eye-icon-edit-mode/smart-table-eye-icon-edit-mode.component';
import { CustomAutocompleteComponent } from './custom-autocomplete/custom-autocomplete.component';
import { ReactiveFormSimpleAutocompleteComponent } from './reactive-form-simple-autocomplete/reactive-form-simple-autocomplete.component';
import { SmartTableWithMultiIconComponent } from './smart-table-with-multi-icon/smart-table-with-multi-icon.component';
import { MdRenderComponent } from './md-render/md-render.component';
import { MarkdownModule } from 'ngx-markdown';
import { CreateUserTokenComponent } from './create-user-token/create-user-token.component';
import { InputOutputModellingComponent } from '../pages/blueprint-designer/input-output-modelling/input-output-modelling.component';
import { MediaInfoCardComponent } from './media-info-card/media-info-card.component';
import { CategorySelectSearchComponent } from './category-select-search/category-select-search.component';
import { ProgressiveAutocompleteComponent } from './progressive-autocomplete/progressive-autocomplete.component';

@NgModule({
  declarations: [
    CustomActionsComponent,
    FormFieldComponent,
    CheckboxComponent,
    PageHeaderComponent,
    SafeHtmlPipePipe,
    SmartTableRouterlinkComponent,
    TableAddComponent,
    InfoComponent,
    PageWrapperComponent,
    DiffIconComponent,
    NumberInputComponent,
    ProfilesComponent,
    AccessForbiddenComponent,
    MessageComponent,
    RadioComponent,
    RBACButtonComponent,
    TabPageHeaderComponent,
    TrimWhiteSpace,
    MapToIterablePipe,
    SmartTableWithBadgeComponent,
    TerminalComponent,
    DateTimePickerComponent,
    ToggleComponent,
    SmartTableWithIconComponent,
    SmartTableWithCountdownComponent,
    SmartTableHyperlinkComponent,
    TagComponent,
    SmartTableIconTooltipComponent,
    SmartTableLongStringEllipsisComponent,
    LinkWithEllipsisComponent,
    SmartTableTextTooltipComponent,
    SmartTableTimeagoTooltipComponent,
    SmartTableLinkWithIconComponent,
    SaveChangesFooterComponent,
    FormLabelComponent,
    BadgeWithIconComponent,
    MultiSelectSearchComponent,
    TagListComponent,
    SelectSingleSearchComponent,
    MultiSelectSearchV2Component,
    SmartTableCellWithEllipsisComponent,
    PageFooterComponent,
    DeleteConfirmationComponent,
    ReactiveFormFieldComponent,
    SmartTableMultiTypeComponent,
    CountdownComponent,
    AppAlertsComponent,
    CustomSpinnerComponent,
    SmartTableTextareaEditorComponent,
    TableSkeletonLoaderComponent,
    ArtifactUriComponent,
    OverrideDetailsComponent,
    ReactiveTextAreaComponent,
    ReactiveToggleComponent,
    KubernetesAccountCreateEditComponent,
    StepperListItemComponent,
    VpnInstructionsComponent,
    UserNoteAlertComponent,
    AppCollapsibleButtonComponent,
    SmartTableToggleComponent,
    QueuedReleasesComponent,
    ButtonDropdownComponent,
    AwsAccountCreateEditComponent,
    AzureAccountCreateEditComponent,
    GcpAccountCreateEditComponent,
    ReactiveRadioGroupComponent,
    CustomBadgeWithTooltipComponent,
    SmartTableWithBulkSelectComponent,
    SmartTableIconSubheadingComponent,
    CoderAccountCreateEditComponent,
    SmartTableEditToggleComponent,
    ReactiveRadioGroupComponent,
    OrganizationAccountDetailsComponent,
    BorderedTextListWithIconComponent,
    CreateCloudAccountIntegrationComponent,
    TokenExpiryUserNoteComponent,
    TokenExpiryGlobalModalComponent,
    CreateVcsAccountIntegrationComponent,
    CopyIconWithTooltipComponent,
    PinImageFormComponent,
    CloseIconComponent,
    ConfirmActionComponent,
    RemoveImageConfirmPopupComponent,
    CardHeaderContentComponent,
    DesignerCoderComponent,
    JsonDynamicFormGroupComponent,
    CardRadioGroupComponent,
    CardRadioGroupWithShowMoreComponent,
    ArrayStringInputComponent,
    DialogPageComponent,
    EnvironmentSelectComponent,
    HierarchyWidgetComponent,
    LabelValueV1Component,
    LabelValueV2Component,
    AlertsChartComponent,
    ReleaseTrendChartComponent,
    DynamicComponentDirective,
    CommitIDsComponent,
    FormJsonEditorComponent,
    ValidationInfoCardComponent,
    ListWithCheckComponent,
    OnboardingComponent,
    CreateBitbucketAccountIntegrationComponent,
    ReleaseNotificationPanelComponent,
    PaasSaasSwitchComponent,
    InviteUserComponent,
    ShellQuoteInputComponent,
    ReactiveGroupedSelectComponent,
    ReactiveFormGroupedAutocompleteComponent,
    SingleSelectSearchComponent,
    VcsAccountCreateEditComponent,
    DropdownWithSearchComponent,
    PageActionButtonsComponent,
    SmartTableLinkComponent,
    SmartTableLinkListComponent,
    SmartTableEyeIconEditModeComponent,
    CustomAutocompleteComponent,
    ReactiveFormSimpleAutocompleteComponent,
    SmartTableWithMultiIconComponent,
    MdRenderComponent,
    CreateUserTokenComponent,
    InputOutputModellingComponent,
    MediaInfoCardComponent,
    CategorySelectSearchComponent,
    ProgressiveAutocompleteComponent,
  ],
  imports: [
    MarkdownModule.forRoot(),
    CommonModule,
    NbLayoutModule,
    NbButtonModule,
    NbUserModule,
    NbActionsModule,
    NbCardModule,
    NbSelectModule,
    RouterModule,
    NbAutocompleteModule,
    FormsModule,
    NbInputModule,
    NbIconModule,
    NbEvaIconsModule,
    NbContextMenuModule,
    NbTooltipModule,
    DirectivesModule,
    NbMenuModule,
    Ng2SmartTableModule,
    NbSpinnerModule,
    NbSidebarModule,
    NbCheckboxModule,
    NbRadioModule,
    NbPopoverModule,
    NbFormFieldModule,
    NbDatepickerModule.forRoot(),
    NbTimepickerModule.forRoot(),
    NbToggleModule,
    CountdownModule,
    ReactiveFormsModule,
    NbAccordionModule,
    TimeagoModule,
    NbTreeGridModule,
    NbTagModule,
    NbTabsetModule,
    NbBadgeModule,
    NgxSkeletonLoaderModule,
    MonacoEditorModule,
    PluralizePipeModule,
    DragDropModule,
    NbListModule,
    AgChartsAngularModule,
    SentenceCasePipeModule,
    NbStepperModule,
  ],
  providers: [],
  exports: [
    CustomActionsComponent,
    FormFieldComponent,
    CheckboxComponent,
    PageHeaderComponent,
    SafeHtmlPipePipe,
    SmartTableRouterlinkComponent,
    TableAddComponent,
    InfoComponent,
    DiffIconComponent,
    NumberInputComponent,
    ProfilesComponent,
    MessageComponent,
    RadioComponent,
    RBACButtonComponent,
    TabPageHeaderComponent,
    TrimWhiteSpace,
    MapToIterablePipe,
    TerminalComponent,
    ToggleComponent,
    SmartTableWithBadgeComponent,
    SmartTableWithCountdownComponent,
    TagComponent,
    SmartTableIconTooltipComponent,
    LinkWithEllipsisComponent,
    SmartTableLongStringEllipsisComponent,
    SmartTableTextTooltipComponent,
    SmartTableTimeagoTooltipComponent,
    SmartTableWithBadgeComponent,
    DateTimePickerComponent,
    SaveChangesFooterComponent,
    FormLabelComponent,
    MultiSelectSearchComponent,
    TagListComponent,
    SelectSingleSearchComponent,
    MultiSelectSearchV2Component,
    SmartTableCellWithEllipsisComponent,
    PageFooterComponent,
    DeleteConfirmationComponent,
    ReactiveFormFieldComponent,
    SmartTableMultiTypeComponent,
    CountdownComponent,
    AppAlertsComponent,
    CustomSpinnerComponent,
    TableSkeletonLoaderComponent,
    ArtifactUriComponent,
    OverrideDetailsComponent,
    ReactiveTextAreaComponent,
    ReactiveToggleComponent,
    KubernetesAccountCreateEditComponent,
    StepperListItemComponent,
    VpnInstructionsComponent,
    UserNoteAlertComponent,
    AppCollapsibleButtonComponent,
    SmartTableToggleComponent,
    QueuedReleasesComponent,
    ButtonDropdownComponent,
    AwsAccountCreateEditComponent,
    AzureAccountCreateEditComponent,
    GcpAccountCreateEditComponent,
    ReactiveRadioGroupComponent,
    CustomBadgeWithTooltipComponent,
    SmartTableWithBulkSelectComponent,
    SmartTableIconSubheadingComponent,
    CoderAccountCreateEditComponent,
    SmartTableEditToggleComponent,
    ReactiveRadioGroupComponent,
    OrganizationAccountDetailsComponent,
    BorderedTextListWithIconComponent,
    CreateCloudAccountIntegrationComponent,
    TokenExpiryUserNoteComponent,
    TokenExpiryGlobalModalComponent,
    CreateVcsAccountIntegrationComponent,
    CopyIconWithTooltipComponent,
    PinImageFormComponent,
    ConfirmActionComponent,
    CloseIconComponent,
    RemoveImageConfirmPopupComponent,
    CardHeaderContentComponent,
    DesignerCoderComponent,
    JsonDynamicFormGroupComponent,
    CardRadioGroupWithShowMoreComponent,
    ArrayStringInputComponent,
    DialogPageComponent,
    EnvironmentSelectComponent,
    HierarchyWidgetComponent,
    LabelValueV1Component,
    LabelValueV2Component,
    AlertsChartComponent,
    ReleaseTrendChartComponent,
    CommitIDsComponent,
    FormJsonEditorComponent,
    ValidationInfoCardComponent,
    ListWithCheckComponent,
    OnboardingComponent,
    CreateBitbucketAccountIntegrationComponent,
    ReleaseNotificationPanelComponent,
    PaasSaasSwitchComponent,
    InviteUserComponent,
    ShellQuoteInputComponent,
    ReactiveGroupedSelectComponent,
    ReactiveFormGroupedAutocompleteComponent,
    VcsAccountCreateEditComponent,
    DropdownWithSearchComponent,
    PageActionButtonsComponent,
    SmartTableLinkComponent,
    SmartTableWithIconComponent,
    SingleSelectSearchComponent,
    SmartTableLinkListComponent,
    CustomAutocompleteComponent,
    ReactiveFormSimpleAutocompleteComponent,
    SmartTableWithMultiIconComponent,
    MdRenderComponent,
    CreateUserTokenComponent,
    InputOutputModellingComponent,
    MediaInfoCardComponent,
    CategorySelectSearchComponent,
    ProgressiveAutocompleteComponent,
  ],
})
export class ComponentsModule {}
